'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAppInForeground = exports.setAppInBackground = exports.changeLocation = undefined;
exports.setWindowVisible = setWindowVisible;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var changeLocation = exports.changeLocation = (0, _reduxActions.createAction)(_ActionTypes2.default.CHANGE_WINDOW_LOCATION);

var setAppInBackground = exports.setAppInBackground = (0, _reduxActions.createAction)(_ActionTypes2.default.APP_IN_BACKGROUND);
var setAppInForeground = exports.setAppInForeground = (0, _reduxActions.createAction)(_ActionTypes2.default.APP_IN_FOREGROUND);

function setWindowVisible(isVisible) {
  return function (dispatch) {
    if (isVisible) {
      dispatch(setAppInForeground());
    } else {
      dispatch(setAppInBackground());
    }
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/WindowActions.js
// module id = 197
// module chunks = 0 1